(function () {
  function revealBatch(root) {
    var batch = parseInt(root.getAttribute('data-mobile-batch'), 10) || 2;
    var hidden = root.querySelectorAll('.magio-product-grid__cell--mobile-hidden');
    if (!hidden.length) return false;

    var count = 0;
    hidden.forEach(function (cell) {
      if (count >= batch) return;
      cell.classList.remove('magio-product-grid__cell--mobile-hidden');
      cell.classList.add('magio-product-grid__cell--mobile-revealed');
      count += 1;
    });

    hidden = root.querySelectorAll('.magio-product-grid__cell--mobile-hidden');
    if (!hidden.length) {
      root.classList.add('is-mobile-expanded');
      var moreWrap = root.querySelector('.magio-product-grid__mobile-more');
      if (moreWrap) moreWrap.hidden = true;
      var btn = root.querySelector('[data-magio-pg-show-more]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }

    return true;
  }

  function init(root) {
    if (!root || root.getAttribute('data-mobile-pg-init') === '1') return;
    if (!root.classList.contains('magio-product-grid--mobile-truncate')) return;

    var hidden = root.querySelectorAll('.magio-product-grid__cell--mobile-hidden');
    if (!hidden.length) return;

    root.setAttribute('data-mobile-pg-init', '1');

    var btn = root.querySelector('[data-magio-pg-show-more]');
    var sentinel = root.querySelector('[data-magio-pg-show-more-sentinel]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var observer = null;
    var scrollPrimed = false;

    function onRevealRequest() {
      if (!mobileQuery.matches) return;
      revealBatch(root);
    }

    if (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        onRevealRequest();
      });
    }

    function bindObserver() {
      if (observer || !sentinel) return;

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || !scrollPrimed) return;
            onRevealRequest();
          });
        },
        { root: null, rootMargin: '0px 0px 10% 0px', threshold: 0.01 }
      );

      observer.observe(sentinel);
    }

    function unbindObserver() {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }

    function primeScroll() {
      if (scrollPrimed) return;
      scrollPrimed = true;
    }

    window.addEventListener('scroll', primeScroll, { passive: true, once: true });
    window.addEventListener('touchmove', primeScroll, { passive: true, once: true });

    function syncMode() {
      if (!mobileQuery.matches) {
        unbindObserver();
        return;
      }
      bindObserver();
    }

    syncMode();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncMode);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(syncMode);
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.magio-product-grid--mobile-truncate').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
